import React, { Component } from 'react';

import App from './App.jsx';

import './css/Aviso.css';

const warning = require('../src/css/img/warning-02.png');

type T_AvisoProps = {
  app: App,
};

type T_AvisoState = {
  show: boolean,
};
//./css/img/warning-02.png /home/pnahumm/GDB/gdb/src/css/img/warning-02.png

export default class Aviso extends Component<T_AvisoProps, T_AvisoState> {
  componentDidMount() {
    const app = this.props.app;
  }
  close_modal = () => {
    this.props.app.setState({ show_aviso: false });
  };

  render() {
    return (
      <div className="modal">
        <div id="miModal" className="modal" /* onClick={this.close_modal} */>
          <div className="modal-contenido">
            <div className="header">
              <img src={warning} className="imagen" />
              <h1 className="titulo">Atención</h1>
              <img src={warning} className="imagen" />
            </div>
            <div>
              <h4 className="text">
                Informamos que durante el día de hoy, jueves 14 de octubre, 
                a partir de las <b>15:00 hrs (Ciudad de México)</b>,
                nuestra plataforma GeoDatabase se encontrará bajo mantención por un período
                de <b>12 horas</b>.
              </h4>
              {/* <h4 className="apologize">Rogamos nos disculpen.</h4> */}
            </div>
            <div>
              <button className="boton" onClick={this.close_modal}>
                Entendido
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Aviso.jsx